import { useLocation, useParams } from '@xing-com/crate-core-router';
import { ErrorContextProvider } from '@xing-com/crate-entity-pages-common';
import { SubpageContainer } from '@xing-com/crate-entity-pages-subpage';
import type { Xinglet } from '@xing-com/crate-xinglet';

import { App } from './app';

export default class ArticleViewer implements Xinglet {
  public getComponent() {
    return (): JSX.Element => {
      const { slug, param } = useParams();
      const location = useLocation();

      const isWebview = /^\/pages\/webview/.test(location.pathname);

      return (
        <ErrorContextProvider>
          <SubpageContainer
            pageSlug={slug}
            pageType="about_us"
            param={param}
            isWebview={isWebview}
          >
            <App />
          </SubpageContainer>
        </ErrorContextProvider>
      );
    };
  }
}
